<template>
  <transition name="dialog">
    <div v-show="show==='OPEN'" class="dialog-cover login-popup-wrap">
      <div class="dialog-box">
        <i class="dialog-close-btn dialog-close" @click.prevent="onClick"></i>
        <div class="dialog-body">
          <login-form :is-popup="true" />
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
/**
 * 弹窗登录
 * @example
 * <login-popup v-mode="ASK|OPEN|CLOSE" @success="" @fail="" @cancel="" />
 */
import user from "./user";
import loginForm from "./view.vue";

export default {
  name: "login-popup",
  props: {
    /* ASK询问,OPEN直接显示form，CLOSE关闭 */
    value: {
      type: String,
      default: "CLOSE"
    }
  },
  data() {
    return {
      show: this.value
    };
  },
  mounted() {
    if (this.show === "ASK") {
      this.showAsk();
    } else if (this.show === "OPEN") {
      this.onOpenForm();
    }
  },
  watch: {
    value(v) {
      this.show = v;
      if (v === "ASK") {
        this.showAsk();
      } else if (v === "OPEN") {
        this.onOpenForm();
      }
    },
    show(v) {
      this.$emit("input", v);
    }
  },
  methods: {
    showAsk() {
      this.$dialog({
        title: "提示",
        content: "登录后才能进行相应操作！\n确认登录?"
      })
        .$on("close", this.onCancel)
        .$on("ok", this.onOpenForm);
    },
    onClick(e) {
      var t = e.target,
        ct = e.currentTarget;
      if (t === ct) {
        this.show = "CLOSE";
        this.onCancel();
        return;
      }
      while (t && t !== ct) {
        if (t.classList.contains("dialog-close")) {
          this.show = "CLOSE";
          this.onCancel();
          break;
        }
        t = t.parentNode;
      }
    },
    //取消登录
    onCancel() {
      if (this.show !== "OPEN") {
        this.show = "CLOSE";
        this.$emit("cancel");
        user.off("success").off("fail");
      }
    },
    //登录失败
    onFail(err) {
      this.$emit("fail", err);
    },
    //登录成功
    onSuccess(info) {
      this.show = "CLOSE";
      this.$emit("success", info);
    },
    onOpenForm(dialog) {
      user.on("fail", this.onFail).on("success", this.onSuccess);
      if (this.show === "ASK") {
        dialog.show = false;
        this.show = "OPEN";
      }
    }
  },
  components: {
    loginForm
  }
};
</script>

<style>
.login-popup-wrap > .dialog-box {
  width: 9rem;
  margin-top: 10em;
}
.login-form-wrap {
  margin: 5%;
}
.login-form-wrap > .tab-wrap {
  border-bottom-color: transparent;
}
.login-form-wrap .tab {
  height: auto;
  line-height: 3;
  text-align: center;
  margin-bottom: 1em;
}
.login-form-wrap .tab > a {
  display: inline-block;
  padding: 0 0.8em;
  box-sizing: border-box;
}
.login-form-wrap .tab > a.on {
  position: relative;
  color: #00b38b;
}
.login-form-wrap .tab > a.on:after {
  position: absolute;
  content: "";
  left: 50%;
  bottom: 0;
  height: 0.2em;
  margin-left: -0.7em;
  background: currentColor;
  left: 0;
  width: 100%;
  margin-left: 0;
}
.login-form-wrap > .tab-container {
  padding-bottom: 0;
}
.login-popup-wrap > .dialog-box > .dialog-close-btn {
  width: 3em;
  height: 3em;
}
</style>



// WEBPACK FOOTER //
// src/components/login/login-popup.vue